const ArrowLeft = ({ className }: { className?: string }) => {
  return (
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_1213_921)">
        <circle cx="23" cy="23" r="16" fill={className ?? 'white'} fillOpacity="0.75" shapeRendering="crispEdges" />
      </g>
      <mask
        id="mask0_1213_921"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="6"
        y="7"
        width="33"
        height="32"
      >
        <rect x="6.2002" y="7" width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1213_921)">
        <path
          d="M24.8669 29.8L18.0669 23L24.8669 16.2L25.5336 16.8667L19.4002 23L25.5336 29.1333L24.8669 29.8Z"
          fill="black"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1213_921"
          x="0"
          y="0"
          width="46"
          height="46"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1213_921" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1213_921" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default ArrowLeft;
